import { APICore } from "helpers/api/apiCore";
import { BulkProgrammesDownloadFileType, BulkProgrammesFileCheckerRemarkType, BulkProgrammesFileDetail, BulkProgrammesFileMakerRemarkType, BulkProgrammesFileVersionType, uploadBulkProgrammesFileType } from "./types";
import { FilterMetadata } from "redux/types";
import config from "config";

const api = new APICore();

function uploadBulkProgrammesFileApi(params: uploadBulkProgrammesFileType) {
    let formData = new FormData();
    formData.append("file", params.bulkProgrammesFile);

    let backendApiUrl = `${config.BACKEND_BASE_URL}/bulk-file/financing_program`;

    const baseUrl = backendApiUrl;
    return api.create(`${baseUrl}`, formData);
}

function fetchBulkProgrammesFileApi(params: FilterMetadata) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/financing_program`;
    return api.get(`${baseUrl}`, params);
}


function downloadBulkProgrammesFileApi(params: BulkProgrammesDownloadFileType) {
    const baseUrl = `${config.BACKEND_BASE_URL}${params.downloadURL}`;
    return api.getFile(`${baseUrl}`, {});
}

function fetchBulkProgrammesFileDetailApi(params: BulkProgrammesFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/financing_program/${params.externalID}`;
    return api.get(`${baseUrl}`, {});
}

function fetchBulkProgrammesFileVersionApi(params: BulkProgrammesFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/versions`;
    return api.get(`${baseUrl}`, params.filter);
}

function bulkProgrammesFilePublishApi(params: BulkProgrammesFileMakerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/publish`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function approveBulkProgrammesFileApi(params: BulkProgrammesFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/approve`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}
function rejectBulkProgrammesFileApi(params: BulkProgrammesFileCheckerRemarkType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalId}/reject`;
    return api.updatePatch(`${baseUrl}`, params.remarkPayload);
}

function fetchBulkFileSpecificProgrammesApi(params: BulkProgrammesFileVersionType) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/financing_program/${params.externalId}/filerecords`;
    return api.get(`${baseUrl}`, params.filter);
}

function deleteBulkProgrammesFileApi(params: BulkProgrammesFileDetail) {
    const baseUrl = `${config.BACKEND_BASE_URL}/bulk-file/${params.externalID}`;
    return api.delete(`${baseUrl}`);
}

export {
    uploadBulkProgrammesFileApi,
    fetchBulkProgrammesFileApi,
    downloadBulkProgrammesFileApi,
    fetchBulkProgrammesFileDetailApi,
    fetchBulkProgrammesFileVersionApi,
    bulkProgrammesFilePublishApi,
    approveBulkProgrammesFileApi,
    rejectBulkProgrammesFileApi,
    fetchBulkFileSpecificProgrammesApi,
    deleteBulkProgrammesFileApi
}